module.exports = __webpack_public_path__ + "static/media/ReportEstrellasIzquierda.50a8b584.png";